const mainPublicListing = async () => {
  if (!customElements.get('trust-settings')) {
    const nmpTrust = (await import("@nmp-trust/all"));
    const pulseEvent = (await import("@finn-no/pulse-sdk"));
    nmpTrust.setupTracker((event) => {
      pulseEvent.trackEvent(event);
    });
  }
}

mainPublicListing();